import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import { Card, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { AppRoutes } from '@/router/routes.ts';

import { NewBooking } from '@/features/NewBooking';

import { calcObjectLoad } from '@/shared/helpers/utils';
import { useGetBookingTypeData } from '@/shared/hooks/useGetBookingTypeData';
import useAppStore from '@/shared/store/app.store';
import useBookingStore from '@/shared/store/booking.store';
import { ILocalData } from '@/shared/types/app.types';
import { BookingType } from '@/shared/types/bookingObjects.types';

import classes from './BookingCard.module.css';

type BookCardProps = {
	type: BookingType;
	data: ILocalData;
	place?: string;
	disabled?: boolean;
};

export const BookingCard = ({ type, place, disabled, data, ...rest }: BookCardProps) => {
	const navigate = useNavigate();
	const isMobile = useAppStore((state) => state.isMobile);
	const { setBookingType } = useBookingStore();
	const bookingData = useGetBookingTypeData({ bookingType: type, className: classes.icon });
	const [openedNewBooking, { close: closeNewBooking, open: openNewBooking }] = useDisclosure(false);

	const handlePushState = () => {
		history.pushState('main', '', '/');
		openNewBooking();
	};
	const handleNewBooking = (type: BookingType) => {
		setBookingType(type);
		isMobile ? handlePushState() : navigate(AppRoutes.BookingNew);
	};

	return (
		<>
			<Card
				className={classNames(classes.root, classes[type], {
					[classes.disabled]: disabled,
				})}
				padding="12px"
				pr={50}
				radius="16px"
				style={{
					height: 100,
				}}
				onClick={() => handleNewBooking(type)}
				{...rest}
			>
				<Flex direction="column" justify="space-between" h={'100%'}>
					<Text fw={600} lh="18px">
						{bookingData?.label}
					</Text>

					{!disabled && (
						<Text className={classes.load} size="xl" fw={700} lh={1} lineClamp={2}>
							{place
								? place
								: `${Number(calcObjectLoad(data.load[type]?.booked ?? 0, data.load[type]?.total ?? 0))}%`}
						</Text>
					)}

					{bookingData?.iconCard}
				</Flex>
			</Card>
			{openedNewBooking && <NewBooking open={openedNewBooking} close={closeNewBooking} />}
		</>
	);
};
